import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GridState } from "src/models/GridState";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import HbsVezneTanimDTO from "src/models/Vezne/HbsVezneTanimDTO";
import HbsVezneTanimDTOService from "src/services/Vezne/VezneTanim/HbsVezneTanimDTO.service";

export const getByAllDataVezneTanim = createAsyncThunk(
    'HbsVezneTanimDTOService/getByAllData',
    async () => {
        const response = await HbsVezneTanimDTOService.getByAllData();
        return response
    }
);

export const deleteRecord = createAsyncThunk(
    'HbsVezneTanimDTOService/deleteRecord',
    async (id: number) => {
        const response = await HbsVezneTanimDTOService.deleteRecord(id);
        return response;
    }
);

export const createUpdate = createAsyncThunk(
    'HbsVezneTanimDTOService/createUpdate',
    async (data: HbsVezneTanimDTO, thunkAPI) => {
        const response = await HbsVezneTanimDTOService.createUpdate(data);
        return response
    }
);

export const getDetayliArama = createAsyncThunk(
    'HbsVezneTanimDTOService/getDetayliArama',
    async (aramaModel: HbsVezneTanimDTO, thunkAPI) => {
        const response = await HbsVezneTanimDTOService.getDetayliArama(aramaModel);
        return response
    }
);

export interface IVezneTanimState extends GridState<HbsVezneTanimDTO> {
    dialog?: boolean;
    searchModel?: HbsVezneTanimDTO;
}

const VezneTanimSlice = createSlice<IVezneTanimState, MapReducerPayloads<IVezneTanimState, {
    setState: IVezneTanimState,
    setDialog: boolean
}>>({
    name: 'VezneTanimState',
    initialState: {
        data: [],
        activeRow: new HbsVezneTanimDTO(),
        searchModel: new HbsVezneTanimDTO(),
        isFetching: true,
        dialog: false,
    },
    reducers: {
        setState: (state, action) => action.payload,
        setDialog: (state, action) => {
            state.dialog = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getByAllDataVezneTanim.pending, (state) => {
            state.isLoading = true
        });
        builder.addCase(getByAllDataVezneTanim.fulfilled, (state, action) => {
            return {
                ...state,
                data: action.payload.data ? action.payload.data : [],
                errorMessage: action.payload.errorMessage,
                isLoading: false,
                isFetching: false
            }
        });
        builder.addCase(deleteRecord.pending, (state) => {
            state.isLoading = true
        });
        builder.addCase(deleteRecord.fulfilled, (state, action) => {
            state.data = state.data.filter(f => f.id !== state.activeRow.id).map((m) => m)
            state.errorMessage = action.payload.errorMessage
            state.isLoading = false
            return state;
        });
        builder.addCase(createUpdate.pending, (state) => {
            state.isLoading = true
        });
        builder.addCase(createUpdate.fulfilled, (state, action) => {
            return {
                ...state,
                activeRow: action.payload.responseCode !== 200 ? state.activeRow : action.payload.data,
                errorMessage: action.payload.errorMessage,
                isLoading: false
            }
        });
        builder.addCase(getDetayliArama.pending, (state) => {
            state.isLoading = true
        });
        builder.addCase(getDetayliArama.fulfilled, (state, action) => {
            return {
                ...state,
                data: action.payload?.data ? action.payload.data : [],
                errorMessage: action.payload.errorMessage,
                isLoading: false,
                isFetching: false
            }
        });
    }
})
export default VezneTanimSlice;